module.exports = __webpack_public_path__ + "static/media/fanghuojiancha.11ad8cf.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp3/fanghuojiancha.mp3
// module id = voWd
// module chunks = 208